import {AlgoliaClient} from '@/api/algoliaclient';

export function CreateAlgoliaKeyProviderMixin(featureName, indices) {
  return {
    name: 'AlgoliaKeyProvider',
    data() {
      return {
        algoliaClient: null,
        appID: process.env.VUE_APP_ALGOLIA_APP_ID,
        intervalID: ''
      }
    },
    methods: {
      initClient() {
        this.algoliaClient = AlgoliaClient.create({
          appID: this.appID,
          featureName,
          indices,
          newKeyCallbacks: [this.updateApiKey]
        })
      },

      async updateApiKey(apiKey) {
        this.$emit('refreshedAlgoliaKey', apiKey)
      }
    },
    created() {
      this.initClient()
    },
  }
}
